<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>
    <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
      <!--<div class="form-group mb-0">
                <base-input placeholder="Search"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search">
                </base-input>
      </div>-->
    </form>

    <div class="row" id="div-edit-admin-profile">
      <div class="col-md-4">
        <modal
          :show.sync="modals.modal3"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">ADMIN PROFILE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        alternative
                        label="Name"
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        v-model="name"
                        :disabled="true"
                      />
                    </div>
                  </div>
                  <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">Change Password</h6>
                  <div>
                    <div class="row">
                      <div class="col-lg-12">
                        <base-input
                          alternative
                          label="Current Password"
                          placeholder="Current Password"
                          input-classes="form-control-alternative"
                          type="password"
                          v-model="currentPassword"
                          :required="true"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <base-input
                          alternative
                          label="New Password"
                          placeholder="New Password"
                          input-classes="form-control-alternative"
                          type="password"
                          v-model="newPassword"
                          :required="true"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <base-input
                          alternative
                          label="Confirm Password"
                          placeholder="Confirm Password"
                          input-classes="form-control-alternative"
                          type="password"
                          v-model="confirmPassword"
                          :required="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button type="danger" class="my-4" @click="modals.modal3 = false">Cancel</base-button>
                    <base-button type="success" class="my-4" @click="changePassword()">Update</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown dropleft">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="img/theme/empty_profile.png" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold"></span>
            </div>
          </div>

          <template>
            <!-- <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
            </div>-->
            <!-- <router-link to="/profile" class="dropdown-item"> -->
            <button
              class="dropdown-item"
              @click="modals.modal3 = true; show = false; currentPassword = ''; newPassword = ''; confirmPassword = ''"
            >
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </button>
            <!-- </router-link> -->
            <!--                         <div class="dropdown-divider"></div>
            -->
            <button v-on:click="logOut()" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </button>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import Modal from "./../components/Modal.vue";

export default {
  data() {
    return {
      show: true,
      message: "Something is wrong.",
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      modals: {
        modal3: false
      },
      name: "Administrator",
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  components: {
    Modal
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logOut() {
      localStorage.removeItem("access_token");
      this.$router.push("login");
    },
    changePassword() {
      this.$store
        .dispatch("changePassword", {
          OldPassword: this.currentPassword,
          NewPassword: this.newPassword,
          ConfirmPassword: this.confirmPassword
        })
        .then(response => {
          if (response.status == 200) {
            this.modals.modal3 = false;
          } else {
            this.show = true;
          }
        })
        .catch(error => {
          for (var item in error.response.data) {
            if (error.response.data[item] != "The request is invalid.") {
              for (var item2 in error.response.data[item]) {
                this.message = error.response.data[item][item2][0];
                break;
              }
              break;
            }
            // console.log(error.response.data[item]);
          }

          this.show = true;
        });
    }
  }
};
</script>
